import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop
 * - Scrolls window to top whenever the pathname changes.
 * - Uses useLayoutEffect for immediate execution before paint
 */
export default function ScrollToTop(): null {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    // Disable automatic scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Force immediate scroll to top
    const scrollToTop = () => {
      // Try multiple scroll methods
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    scrollToTop();

    // Additional scrolls with delays to catch any timing issues
    const timeouts = [
      setTimeout(scrollToTop, 0),
      setTimeout(scrollToTop, 10),
      setTimeout(scrollToTop, 50),
      setTimeout(scrollToTop, 100),
      setTimeout(scrollToTop, 200)
    ];

    // Cleanup timeouts
    return () => {
      timeouts.forEach(clearTimeout);
    };
  }, [pathname]);

  return null;
}
